export default __webpack_public_path__ + "static/media/Icons-LowCost.cc9ce7a0.svg";